// Kategori ruangan Unit Cost Fasilitas (harus sama dengan FASILITAS_DEP_CATEGORIES di backend)
export const FAS_CATEGORIES = [
    "Ruang Kelas 3",
    "Ruang Kelas 2",
    "Ruang Kelas 1",
    "Ruang VIP",
    "Ruang VVIP",
    "NON Kelas",
    "HCU",
    "ICU",
    "Perinatologi",
    "ISOLASI",
    "NICU",
    "Ruang OK",
    "Ruang VK",
];
